export default __webpack_public_path__ + "static/media/StageCurtainLeft.4981c49c.svg";